import PropTypes from 'prop-types'
import {translate} from 'react-i18next'
import compose from 'lodash.compose';
import Link from './link'
import React from 'react';

function Menu({ onToggleMenu, t, i18n: { language } }) {
  return (
    <nav id="menu">
      <div className="inner">
        <ul className="links">
          <li><Link href="/"><a><span onClick={onToggleMenu}>{t('menu.home')}</span></a></Link></li>
          <li><Link href="/catalogues"><a><span onClick={onToggleMenu}>{t('menu.catalogues')}</span></a></Link></li>
          <li><Link href="/downloads"><a><span onClick={onToggleMenu}>{t('menu.downloads')}</span></a></Link></li>
          <li><Link href="/videos"><a><span onClick={onToggleMenu}>{t('menu.videos')}</span></a></Link></li>
          <li><Link href="/about"><a><span onClick={onToggleMenu}>{t('menu.about')}</span></a></Link></li>
          <li><Link href="/about/certificates"><a><span onClick={onToggleMenu}>{t('menu.certificates')}</span></a></Link></li>
        </ul>
        <form method="get" action={`/${language}/search`}>
          <label htmlFor="search">{t('menu.search')}</label>
          <input
            type="search"
            name="search"
            id="search"
            placeholder="Codice o cross-reference"
            autoComplete="false"
          />
        </form>
      </div>
      <a className="close" onClick={onToggleMenu} href="javascript:;">{t('close')}</a>
    </nav>
  );
}

Menu.propTypes = {
  onToggleMenu: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};


export default compose(
  translate(),
)(Menu);
